<template>
  <SpectreToastGroup :toasts="queue" />
  <div class="flex min-h-dvh flex-col">
    <div class="sticky top-0 z-50 min-h-16">
      <SpectreNavigation
        :links="($page.props.navigation as NavigationLinkCollection[])"
        product="spectre_social_v2"
        :user="{ name: $page.props.auth.user.name ?? '', roles: $page.props.auth.user.roles }"
        :environment="$page.props.app.env"
        @request-access="handleRequestAccess"
      />
    </div>
    <slot v-bind="$attrs" />
  </div>
</template>

<script setup lang="ts">
import { router, usePage } from '@inertiajs/vue3';
import { SpectreNavigation, SpectreToastGroup, useToasts, type NavigationLinkCollection } from '@agentsoftware/spectre-ui';
import { whenever } from '@vueuse/core';
import { requestProductAccess } from '@/routes';

const page = usePage();

const { enqueue, queue } = useToasts();

whenever(() => page.props.flash.toasts, (newValue) => {
  newValue.forEach((toast) => {
    enqueue(toast.label, toast.description, toast.type);
  });
});

const handleRequestAccess = (product: string) => {
  router.post(requestProductAccess.url(), { product }, {
    only: ['navigation', 'flash'],
    preserveScroll: true,
  });
};
</script>
